import { Box, Flex } from '@chakra-ui/react';

interface StepContainerProps {
  isEnabled: boolean;
  showArrow?: boolean;
  children: React.ReactNode;
}

const StepContainer = ({
  isEnabled,
  showArrow = true,
  children,
}: StepContainerProps) => {
  const getBoxStyles = () => {
    const baseArrowStyles = {
      content: '""',
      position: 'absolute',
      top: '50%',
      right: '-10px',
      transform: 'translateY(-50%)',
      width: 0,
      height: 0,
      borderLeft: '10px solid',
      borderTop: '10px solid transparent',
      borderBottom: '10px solid transparent',
      zIndex: 1,
    };

    if (isEnabled) {
      return {
        borderColor: 'brand.500',
        bg: 'white',
        opacity: '1',
        ...(showArrow && {
          _after: {
            ...baseArrowStyles,
            borderLeftColor: 'brand.500',
          },
        }),
      };
    }

    return {
      borderColor: 'gray.300',
      bg: 'gray.50',
      opacity: '0.6',
      ...(showArrow && {
        _after: {
          ...baseArrowStyles,
          borderLeftColor: 'gray.300',
        },
      }),
    };
  };

  return (
    <Box
      flex="1"
      p="20px"
      border="2px solid"
      borderRadius="lg"
      position="relative"
      {...getBoxStyles()}
    >
      <Flex direction="column" align="center" gap="15px">
        {children}
      </Flex>
    </Box>
  );
};

export default StepContainer;
